<template>
  <div>
    <add-assignment
      :dialogVisible="modals.showAddAssignment"
      v-on:closed="handleLeaveAssignment"
      v-on:done="handleCreateAssignmentSuccess"
      ref="addAssignment"
      
    />
    <leave-create-study-set-modal
      :dialogVisible="modals.showLeaveAssignment"
      append-to-body
      v-on:closed="modals.showLeaveAssignment = false"
      v-on:leave="handleConfirmLeaveAssignment"
    />
    <assign-to-class-success-modal
      :createdAssignments="createdAssignments"
      :dialogVisible="modals.showAssignToClassSuccess"
      :page="2"
      append-to-body
      v-on:closed="handleReviewAssignmentSuccess"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddAssignment from "@/components/modals/scenario/AddAssignment";
import LeaveCreateStudySetModal from "@/components/modals/studysets/LeaveCreateStudySetModal";
import AssignToClassSuccessModal from "@/components/modals/studysets/AssignToClassSuccessModal";

export default {
  components: {
    AddAssignment,
    LeaveCreateStudySetModal,
    AssignToClassSuccessModal,
  },
  data() {
    return {
      modals: {
        showAddAssignment: false,
        showLeaveAssignment: false,
        showAssignToClassSuccess: false,
      },
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    organizationData() {
      return this.$store.state.organization.currentOrganization;
    },
    ...mapGetters("organization", ["isOrganizationAdmin", "isOrganizationAssociateAdmin", "currentOrganizationType"]),
    ...mapGetters({
      createdAssignments: "aiTutor/getCreatedAssignments",
    }),
  },
  methods: {
    handleLeaveAssignment() {
      if (this.$refs.addAssignment.emptyCheck() == 1) this.modals.showLeaveAssignment = true;
      else this.modals.showAddAssignment = false;
    },
    handleConfirmLeaveAssignment() {
      this.$refs.addAssignment.reset();
      this.modals.showAddAssignment = false;
      this.modals.showLeaveAssignment = false;
    },
    handleCreateAssignmentSuccess() {
      this.$refs.addAssignment.reset();
      this.modals.showAddAssignment = false;
      this.modals.showLeaveAssignment = false;
      this.modals.showAssignToClassSuccess = true;
    },
    handleReviewAssignmentSuccess() {
      this.modals.showAssignToClassSuccess = false;
      this.$emit("reload");
    },
    handleAssignToClassScenario(data) {
      this.$refs.addAssignment.setInitialScenario(data);
      this.modals.showAddAssignment = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

::v-deep .el-popper {
  margin-left: -75px !important;
  margin-top: 40px !important;
}

::v-deep .el-table__body,
::v-deep .el-table__footer,
::v-deep .el-table__header {
  table-layout: auto !important;
  width: 100% !important;
}

::v-deep .elsa-table-layout {
  padding-top: 0px;
}

::v-deep .el-table__column-filter-trigger i {
  font-size: 16px;
}

::v-deep .el-table .el-table-column--selection .cell {
  padding-left: 16px;
}

::v-deep .search-box.elsa-input {
  margin-top: 16px;
}

::v-deep .el-input .el-input__inner {
  padding: 24px 0px !important;
  opacity: 1 !important;
}

.header-end {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  & > div {
    margin: 0px 5px;
  }
}

.more-action-text {
  padding: 16px 0px;
  font-weight: 600;
  margin-right: 8px;
}

::v-deep .el-input {
  height: 48px !important;
}

::v-deep .el-input-group__append {
  border-radius: 40px !important;
}

::v-deep .el-table__empty-block {
  width: 100% !important;
}
</style>
